import { render, staticRenderFns } from "./FilterDetail.vue?vue&type=template&id=6aa4f809&scoped=true&"
import script from "./FilterDetail.vue?vue&type=script&lang=js&"
export * from "./FilterDetail.vue?vue&type=script&lang=js&"
import style0 from "./FilterDetail.vue?vue&type=style&index=0&id=6aa4f809&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4f809",
  null
  
)

export default component.exports